import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// FastAPI returns `detail` as a plain string for explicit HTTPException(...)
// but as a list of {msg, loc, ...} objects for Pydantic validation errors (422).
// Rendering that list directly as JSX crashes React ("Objects are not valid as
// a React child"), which takes down the whole page. Always go through this.
export function getApiErrorMessage(err, fallback) {
  const detail = err?.response?.data?.detail;
  if (!detail) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((item) => (typeof item === "string" ? item : item?.msg || fallback)).join(" · ") || fallback;
  }
  return fallback;
}
